import { ContactButtons } from "../site/ContactButtons";
import React from "react";
import { MapPin, Truck, BadgeCheck, MessageCircle } from "lucide-react";
import { useSite } from "../../context/SiteContext";
import { Container, Reveal, EmailPill } from "../site/Reveal";
import { Link } from "react-router-dom";
import { slugify, STATES as STATE_LIST } from "../../lib/states";

const STATES = [
  "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "Florida", "Georgia",
  "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland",
  "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey",
  "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina",
  "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming",
];
const CITIES = ["New York, NY", "Los Angeles, CA", "Chicago, IL", "Houston, TX", "Phoenix, AZ", "Philadelphia, PA", "San Antonio, TX", "San Diego, CA", "Dallas, TX", "Miami, FL", "Atlanta, GA", "Orlando, FL", "Nashville, TN", "Charlotte, NC", "Detroit, MI", "Seattle, WA"];

const Nationwide = () => {
  const { content, openChat, t, lang } = useSite();
  const brand = content?.brand || "StripWise";
  return (
    <section id="nationwide" className="py-20 md:py-24" data-testid="nationwide-section" aria-labelledby="nationwide-title">
      <Container>
        <div className="grid gap-10 lg:grid-cols-[1fr_1.1fr] lg:gap-14">
          <Reveal>
            <div className="sw-section-eyebrow">{t("Serving All 50 States")}</div>
            <h2 id="nationwide-title" className="sw-h2 mt-3">{t("Sell Your Extra Test Strips From Anywhere in the USA")}</h2>
            {lang === "es" ? <p className="mt-5 text-[16.5px] leading-[1.75] text-[#4b5d5a]">{t("nationwide_body", { brand })}</p> : <p className="mt-5 text-[16.5px] leading-[1.75] text-[#4b5d5a]">
              Wherever you live, {brand} makes it simple to sell sealed, unexpired supplies you no longer need. We accept items such as
              <b className="text-[#0f2e2a]"> Dexcom G6 &amp; G7 sensors, FreeStyle Libre 2 &amp; 3, Omnipod 5 &amp; Dash pods, OneTouch Verio, Contour Next, Accu-Chek Guide</b> and more.
              Get a free quote, ship with the prepaid label we send you, and choose how you want to be paid.
            </p>}
            <div className="mt-7 grid gap-3 sm:grid-cols-3">
              {[[Truck, "Free prepaid label"], [BadgeCheck, "Clear, fair offers"], [MapPin, "All 50 states"]].map(([I, label]) => (
                <div key={label} className="flex items-center gap-2.5 rounded-xl border border-[#e3f0ed] bg-white px-4 py-3 text-[14.5px] font-semibold text-[#0f2e2a]">
                  <I size={17} className="shrink-0 text-[#0e8c7f]" />{t(label)}
                </div>
              ))}
            </div>
            <button onClick={() => openChat(t("Hi! I'd like to sell my test strips. Which state do you ship from?"))} className="sw-btn-primary mt-7" data-testid="nationwide-chat-btn">
              <MessageCircle size={16} /> {t("Get My Free Quote")}
            </button>
            <div><EmailPill className="mt-4" /></div>
          </Reveal>
          <Reveal delay={120} className="rounded-[26px] border border-[#e3f0ed] bg-[#f7fcfb] p-6 md:p-8">
            <h3 className="text-[18px] font-bold text-[#0f2e2a]">{t("Popular cities we buy from")}</h3>
            <ul className="mt-4 flex flex-wrap gap-2">
              {CITIES.map((c) => {
                const [city, abbr] = c.split(", ");
                const st = STATE_LIST.find((x) => x.abbr === abbr);
                const to = st && st.cities.includes(city) ? `/sell-test-strips/${st.slug}/${slugify(city)}` : st ? `/sell-test-strips/${st.slug}` : "/sell-test-strips";
                return (
                  <li key={c}><Link to={to} onClick={() => window.scrollTo(0, 0)} className="block rounded-full border border-[#d6efe9] bg-white px-3.5 py-1.5 text-[13.5px] font-medium text-[#0b6f65] hover:border-[#0e8c7f]">{c}</Link></li>
                );
              })}
            </ul>
            <h3 className="mt-7 text-[18px] font-bold text-[#0f2e2a]">{t("States we serve")}</h3>
            <ul className="mt-3 grid grid-cols-2 gap-x-4 gap-y-1.5 text-[13.5px] text-[#4b5d5a] sm:grid-cols-3 md:grid-cols-4">
              {STATES.map((s) => <li key={s}><Link to={`/sell-test-strips/${slugify(s)}`} onClick={() => window.scrollTo(0, 0)} className="hover:text-[#0e8c7f] hover:underline">{s}</Link></li>)}
            </ul>
            <ContactButtons id="nationwide" className="mt-7" />
          </Reveal>
        </div>
      </Container>
    </section>
  );
};

export default Nationwide;
